import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs/Rx';
import { RegulationsService } from './regulations.service';
import { ApiService } from './api.service';
import { RodoService } from './rodo.service';

@Injectable()
export class RodoGuard {

    constructor(
        private regService: RegulationsService,
        private apiService: ApiService,
        private router: Router,
        private rodoService: RodoService
    ) { }

    canActivate(route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): any {
        return this.rodoService.checkRodo().toPromise().then((accepted) => {
            if (!accepted) {
                //console.log('NOT ACCEPTED redirecting');
                this.router.navigateByUrl('/accepting-rodo');
                return Promise.resolve(false);
            }
            return Promise.resolve(true);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/rodo.guard.ts